import EventEmitter from '../../../lib/helpers/EventEmmiter';

const coef = 0.6;
const fftSize = 32;
const interval = 100;

class AudioListener extends EventEmitter {
    _audio = null;
    _stream = null;
    _audioContext = null;
    _analyzer = null;
    _interval = null;

    constructor (stream, audioContext) {
        super();
        this._stream = stream;
        this._audioContext = audioContext;
        this._init();
    }

    _init() {
        this._analyzer = this._createAnalyzer();

        if (!this._analyzer) return;

        this._audio = this._audioContext.createMediaStreamSource(this._stream);
        this._audio.connect(this._analyzer);

        this._interval = setInterval(this._update.bind(this), interval);
    }

    _createAnalyzer() {
        let analyzer = null;

        try {
            analyzer = this._audioContext.createAnalyser();
        } catch (e) {
            throw '< createAnalyser > is not available in audioContext';

            return analyzer;
        }

        analyzer.fftSize = fftSize;

        this._bufferLength = analyzer.frequencyBinCount;
        this._dataArray = new Uint8Array(this._bufferLength);

        console.log('Length of < for > loop - ', this._bufferLength);

        return analyzer;
    }

    _update() {
        let level = 0;

        this._analyzer.getByteFrequencyData(this._dataArray);

        for (let i = 0; i < this._bufferLength; i++) {
            let segScale = this._dataArray[i] / 255;

            if (segScale > 0.8)
                level = 2;
            else if (segScale > coef)
                level = 1;

            if (level === 2) break;
        }

        this._fireEvent('audio.level', level);
    }

    destroy() {
        this._audio.disconnect(this._analyzer);

        // TODO: unset audio context
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
}

export default AudioListener;